import React, { useContext, useEffect, useState } from 'react';
import proptypes from 'prop-types';
const { bool } = proptypes;
import {
  QueryContext, QueryProvider
} from '@thd-nucleus/data-sources';
import { RecentlyViewedWrapper } from './RecentlyViewedWrapper';
import ZoneCard from '../utils/zone-card';
import { rvDataModel } from '../dataModel';
import { useSearchContext, searchModelDataModel } from '../hooks/useSearchContext';

const PlpRvRenderPlaceholder = ({
  isCategory: isCategoryPageProp,
  isSearch: isSearchPageProp,
  showLoading: shouldShowLoadingProp,
}) => {
  const {
    isSearchPageFromContext,
    isCategoryPageFromMetadata,
    loading,
  } = useSearchContext();

  const { defaultVariables } = useContext(QueryContext) || {};

  const isSearch = isSearchPageProp || isSearchPageFromContext;
  const isCategory = isCategoryPageProp || isCategoryPageFromMetadata;
  const showLoading = shouldShowLoadingProp || loading;

  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);
  let schemeName;

  if (isCategory) {
    schemeName = 'rv_categorypages_rr';
  } else if (isSearch) {
    schemeName = 'rv_search_plp_rr';
  } else {
    schemeName = 'rv_nav_plp_rr';
  }
  if (!schemeName || !isMounted) {
    return null;
  }

  const rvDefaultVariables = {
    ...(typeof defaultVariables?.current?.isBrandPricingPolicyCompliant === 'boolean' && {
      isBrandPricingPolicyCompliant: defaultVariables.current.isBrandPricingPolicyCompliant
    })
  };

  return (
    <div data-component="PlpRvRenderPlaceholder" className="sui-w-full">
      <QueryProvider
        cacheKey="rv-plp-recs"
        defaultVariables={rvDefaultVariables}
        persist
      >
        <RecentlyViewedWrapper
          schemaName={schemeName}
          showLoading={showLoading}
          errorBoundary
          hydrator={{
            delay: 2000,
            className: 'sui-grid',
            tag: ZoneCard,
            id: `${schemeName}-rv`,
            scrollBuffer: 1200
          }}
        />
      </QueryProvider>
    </div>
  );
};

PlpRvRenderPlaceholder.displayName = 'PlpRvRenderPlaceholder';

PlpRvRenderPlaceholder.dataModel = {
  ...rvDataModel,
  ...searchModelDataModel
};

PlpRvRenderPlaceholder.propTypes = {
  isCategory: bool,
  isSearch: bool,
  showLoading: bool
};

PlpRvRenderPlaceholder.defaultProps = {
  isCategory: false,
  isSearch: false,
  showLoading: false
};

export { PlpRvRenderPlaceholder };
